export const ON_LOAD_WIDGET_LIST = "ON_LOAD_WIDGET_LIST";
export const OPEN_CODE_POPUP = "OPEN_CODE_POPUP";
export const SET_EMAIL_FIELD = "SET_EMAIL_FIELD";
export const CLOSE_CODE_POPUP = "CLOSE_CODE_POPUP";
export const ON_SEND_EMAIL_SUCCESS = "ON_SEND_EMAIL_SUCCESS";
export const ON_SEND_EMAIL_FAILD = "ON_SEND_EMAIL_FAILD";

export const OPEN_WIDGET_STAT_POPUP = "OPEN_WIDGET_STAT_POPUP";
export const CLOSE_WIDGET_STAT_POPUP = "CLOSE_WIDGET_STAT_POPUP";
export const ON_LOAD_WIDGET_STAT_SUCCESS = "ON_LOAD_WIDGET_STAT_SUCCESS";

export const OPEN_WIDGET_FORM = "OPEN_WIDGET_FORM";
export const OPEN_WIDGET_EDIT_FORM = "OPEN_WIDGET_EDIT_FORM";
export const CLOSE_WIDGET_FORM = "CLOSE_WIDGET_FORM";
export const SET_WIDGET_FORM_FIELD = "SET_WIDGET_FORM_FIELD";
export const ON_SAVE_WIDGET_FORM_SUCCESS = "ON_SAVE_WIDGET_FORM_SUCCESS";
export const ON_SAVE_WIDGET_FORM_FAILD = "ON_SAVE_WIDGET_FORM_FAILD";
export const ON_LOAD_WIDGET_SUCCESS = "ON_LOAD_WIDGET_SUCCESS";
export const TOGGLE_CATEGORY = "TOGGLE_CATEGORY";
export const CONFIRM_REPLACE = "CONFIRM_REPLACE";
export const ON_LOAD_TEASER_INF_SUCCESS = "ON_LOAD_TEASER_INF_SUCCESS";

export const OPEN_WIDGET_COPY_POPUP = "OPEN_WIDGET_COPY_POPUP";
export const CLOSE_WIDGET_COPY_POPUP = "CLOSE_WIDGET_COPY_POPUP";

export const SET_WIDGET_LIST_SORT = "SET_WIDGET_LIST_SORT";
export const SET_WIDGET_STAT_SORT = "SET_WIDGET_STAT_SORT";

export const ON_COPY_WIDGET_FAILED = "ON_COPY_WIDGET_FAILED";

export const SET_WIDGET_LIST_DATE_RANGE = "SET_WIDGET_LIST_DATE_RANGE";

export const ON_DELETE_WIDGET_SUCCESS = "ON_DELETE_WIDGET_SUCCESS";
export const ON_COPY_WIDGET_SUCCESS = "ON_COPY_WIDGET_SUCCESS";
